<input type="hidden" name="auth" value="Hidden auth"/>